export const embeddedImageGalleryGql = /* GraphQL */ `
... on landingPageContent2023_embeddedImageGallery_BlockType {
    typeHandle
    title:embeddedImageGalleryTitle
    theme:embeddedImageGalleryTheme
    grid:embeddedImageGallery {
        ... on images_Asset {
            alt:altText
            title
            caption
            image:galleryThumbnail {
                srcWebp
                srcset
            }
            imageFull:lpImageTextUncropped {
                srcWebp
                srcset  
            }
        }
    }
}`;
